import React from 'react';
import NotificationList from './NotificationList';

function NotificationListWrapper(props) {
  return <NotificationList />;
}

export default NotificationListWrapper;
